import { defineMessages } from "react-intl";
import { useFormatMessage } from "../Intl/Context";

import FileInputFile from "./FileInputFile";

const FileInputFilesList = props => {
  const {
    files,
    inputFieldName,
    onUploadStart,
    onUploadComplete,
    onRemove,
    attachmentToken
  } = props;

  const t = useFormatMessage();
  const filesEmptyLabel = t(intlMessages.filesEmptyLabel);

  if (!files.length)
    return <li className="uploader-files-empty p-2">{filesEmptyLabel}</li>;

  return (
    <>
      {files.map((file, index) => (
        <FileInputFile
          key={index}
          file={file}
          inputFieldName={inputFieldName}
          onUploadStart={onUploadStart}
          onUploadComplete={onUploadComplete}
          onRemove={onRemove}
          attachmentToken={attachmentToken}
        />
      ))}
    </>
  );
};

export default FileInputFilesList;

const intlMessages = defineMessages({
  filesEmptyLabel: {
    id: "inputs.files.list.empty",
    defaultMessage: "Aucun fichier sélectionné"
  }
});
